export function buildRetouchReviewUrl(token) {
    const { origin, pathname } = window.location;
    const base = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    return `${origin}${base}/#/r/${token}`;
}

export function buildRetouchUploadUrl(token, batchId) {
    const { origin, pathname } = window.location;
    const base = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    return `${origin}${base}/#/r/${token}/upload/${batchId}`;
}

export function getRetouchNameKey(token) {
    return `retouch-review-name:${token}`;
}

export function getRetouchName(token) {
    try {
        return sessionStorage.getItem(getRetouchNameKey(token)) || "";
    } catch {
        return "";
    }
}

export function setRetouchName(token, name) {
    try {
        sessionStorage.setItem(getRetouchNameKey(token), name);
    } catch {
        // Storage is optional.
    }
}
